
document.addEventListener('DOMContentLoaded', function () {

  // Étape 1 : Observer l'ajout du popup (lb-upsell-addon-popup)
  const observerForPopup = new MutationObserver(function (mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const upsellPopup = document.querySelector('lb-upsell-addon-popup');
        if (upsellPopup) {
          observer.disconnect();
          observeProductsInPopup(upsellPopup);
          
        }
      }
    }
  });
  // Démarrer l'observation du body pour détecter l'ajout du popup
  observerForPopup.observe(document.body, { childList: true, subtree: false });
});


function addParagraphsToPopupHeader() {
  const popupHeader = document.querySelector('.lb-addon-popup-header');
  if (popupHeader) {
    // Créer le premier paragraphe
    const paragraph1 = document.createElement('p');
    paragraph1.textContent = "Personnalise ton GeoRide avec nos accessoires et adapte-le à tes besoins, pour une expérience sur-mesure.";
    paragraph1.classList.add('custom-paragraph-1');

    // Créer le deuxième paragraphe
    const paragraph2 = document.createElement('p');
    paragraph2.textContent = "👋 Profite d’un avantage exclusif de -20% pour l’achat d’un minimum de 2 accessoires.";
    paragraph2.classList.add('custom-paragraph-2');

    // Ajouter les paragraphes au header du popup
    popupHeader.appendChild(paragraph1);
    popupHeader.appendChild(paragraph2);
  } else {
    console.error("Header du popup non trouvé.");
  }
}
// Fonction pour observer les produits dans le popup
function observeProductsInPopup(upsellPopup) {
  const observerForProducts = new MutationObserver(function (mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        // Vérifier si les produits sont ajoutés
        const productContainers = upsellPopup.querySelectorAll('.lb-upsell-product-card');
        if (productContainers.length > 0) {
          // Arrêter l'observation des produits
          observer.disconnect();
          // Traiter les produits
          processProducts(productContainers);
           addParagraphsToPopupHeader();
        }
      }
    }
  });
  // Démarrer l'observation du popup pour détecter l'ajout des produits
  observerForProducts.observe(upsellPopup, { childList: true, subtree: true });
}

// Fonction pour traiter les produits
function processProducts(productContainers) {
  productContainers.forEach((container) => {
    // Observer les changements dans le conteneur de produit
    const observer = new MutationObserver(function (mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          // Vérifier si le titre du produit est présent
          const productTitleElement = container.querySelector('.lb-spc-details-name');
          if (productTitleElement) {
            observer.disconnect();
            processProduct(container, productTitleElement);
            // Redémarrer l'observation pour surveiller les futures mises à jour
            observer.observe(container, { childList: true, subtree: true });
          }
        }
      }
    });
    // Démarrer l'observation du conteneur de produit
    observer.observe(container, { childList: true, subtree: true });
  });
}

function processProduct(container, productTitleElement) {

   const cartdrawerpan = document.querySelector('.mm-drawer-cart-filter');
   cartdrawerpan.classList.remove('mm-dc-is-open');
  
  const productTitle = productTitleElement.textContent.trim();

  // Définir la description et le lien en fonction du titre
  let description = '';
  let linkHref = '';
  let linkText = '';

  switch (true) {
    case productTitle.includes('Live Detect'):
      description = "Live Detect te prévient instantanément en cas d'ouverture de ton top-case, valise ou garage.";
      linkHref = 'https://georide.fr/products/live-detect';
      linkText = 'En savoir plus';
      break;
    case productTitle.includes('Live Alarm'):
      description = 'Live Alarm déclenche un son strident pour faire fuir les voleurs, automatiquement ou à distance.';
      linkHref = 'https://georide.fr/products/live-alarm';
      linkText = 'En savoir plus';
      break;
    case productTitle.includes('Live Wheel'):
      description = "Live Wheel surveille la pression et la température de tes pneus, et t'alerte en cas de crevaison.";
      linkHref = 'https://georide.fr/products/live-wheel';
      linkText = 'En savoir plus';
      break;
    default:
      description = 'Découvre ce produit.';
      linkHref = 'https://georide.fr';
      linkText = 'En savoir plus';
  }

   // Créer un élément pour la description
  const descriptionElement = document.createElement('p');
  descriptionElement.textContent = description;
  descriptionElement.style.marginTop = '10px';
  descriptionElement.style.fontSize = '14px';
  descriptionElement.style.color = '#666';

  // Créer un élément pour le lien
  const linkElement = document.createElement('a');
  linkElement.href = linkHref;
  linkElement.textContent = linkText;
  linkElement.style.display = 'block';
  linkElement.style.marginTop = '5px';
  linkElement.style.color = '#007bff';
  linkElement.style.textDecoration = 'none';
  linkElement.style.fontSize = '14px';

  // Trouver le conteneur des détails pour insérer la description et le lien
  const detailsContainer = container.querySelector('.lb-spc-details-cont');
  if (detailsContainer) {
    console.log("Conteneur des détails trouvé pour le produit :", productTitle);

    // Supprimer les anciens éléments (s'ils existent)
    const existingDescription = detailsContainer.querySelector('.custom-description');
    const existingLink = detailsContainer.querySelector('.custom-link');
    if (existingDescription) existingDescription.remove();
    if (existingLink) existingLink.remove();

    // Ajouter des classes pour identifier les éléments ajoutés
    descriptionElement.classList.add('custom-description');
    linkElement.classList.add('custom-link');

    // Insérer la description et le lien
    detailsContainer.appendChild(descriptionElement);
    detailsContainer.appendChild(linkElement);
  } else {
    console.error("Conteneur des détails non trouvé pour le produit :", productTitle);
  }
}
